import {
  HeaderWrapper,
  TabsRow,
  ControlsContainer,
} from '../../../components/Dashboard/styles/DashboardHeaderStyles'
import { SkeletonBox } from '../styles/SkeletonStyles'
import { BORDER_RADIUS } from '../../../styles/theme'

export function SkeletonDashboardHeader() {
  return (
    <HeaderWrapper>
      <SkeletonBox $width="160px" $height="36px" $radius={BORDER_RADIUS.sm} />
      <TabsRow>
        <SkeletonBox
          $width="52px"
          $height="21px"
          $radius={BORDER_RADIUS.sm}
          style={{ marginTop: '8px', marginBottom: '12px' }}
        />
        <SkeletonBox
          $width="70px"
          $height="21px"
          $radius={BORDER_RADIUS.sm}
          style={{ marginTop: '8px', marginBottom: '12px' }}
        />
        <ControlsContainer>
          <SkeletonBox $width="200px" $height="32px" $radius={BORDER_RADIUS.md} />
          <SkeletonBox $width="118px" $height="32px" $radius={BORDER_RADIUS.md} />
        </ControlsContainer>
      </TabsRow>
    </HeaderWrapper>
  )
}
